<div class="panel-footer" [class.has-gateway]="!!gateway || multiGateway">
  <!-- Gateway: antena + nombre + pildora de estado ON/OFF -->
  <div class="panel-footer__gateway" *ngIf="gateway && !multiGateway">
    <span class="panel-footer__antenna">
      <app-image-color
        [url]="'img/icons/gateway.svg'"
        [color]="'#3a3f44'"
        [height]="'28px'"
        [width]="'28px'"
      ></app-image-color>
    </span>
    <div class="panel-footer__gateway-text">
      <small class="panel-footer__label">
        {{ "panel-alerts.gateway" | translate }} {{ gateway.name }}
      </small>
      <span
        class="panel-footer__status"
        [class.is-connected]="gateway.connected"
        placement="top"
        container="body"
        [ngbTooltip]="gatewayStatusKey | translate"
      >
        <span class="panel-footer__dot"></span>
        {{ gatewayPillKey | translate }}
      </span>
    </div>
  </div>

  <!-- Varios gateways en el lote: resumen + detalle en popover (hover; en tactil, al tocar) -->
  <div
    class="panel-footer__gateway is-multi"
    *ngIf="multiGateway"
    [ngbPopover]="gatewaysDetail"
    triggers="mouseenter:mouseleave"
    placement="top"
    container="body"
  >
    <span class="panel-footer__antenna">
      <app-image-color
        [url]="'img/icons/gateway.svg'"
        [color]="'#3a3f44'"
        [height]="'28px'"
        [width]="'28px'"
      ></app-image-color>
    </span>
    <div class="panel-footer__gateway-text">
      <span class="panel-footer__multi-label">
        {{ "panel-alerts.gateways-count" | translate: { count: lotGateways.length } }}
      </span>
      <!-- Solo circulo de color + cantidad: verde conectados, rojo desconectados -->
      <span class="panel-footer__pills">
        <span class="panel-footer__count-pill is-connected" *ngIf="onlineCount > 0">
          <span class="panel-footer__dot"></span>
          {{ onlineCount }}
        </span>
        <span class="panel-footer__count-pill" *ngIf="offlineCount > 0">
          <span class="panel-footer__dot"></span>
          {{ offlineCount }}
        </span>
      </span>
    </div>
  </div>

  <!-- Detalle: nombre y equipos a la izquierda, estado a la derecha; una fila por gateway -->
  <ng-template #gatewaysDetail>
    <div class="panel-footer__gw-list">
      <h5 class="panel-footer__gw-title">{{ "panel-alerts.gateways-detail" | translate }}</h5>
      <div class="panel-footer__gw-row" *ngFor="let item of lotGateways">
        <div class="panel-footer__gw-info">
          <span class="panel-footer__gw-name" [title]="item.name">{{ item.name }}</span>
          <small class="panel-footer__gw-count">
            {{ (item.feeders === 1 ? "panel-alerts.gateway-feeder" : "panel-alerts.gateway-feeders") | translate: { count: item.feeders } }}
          </small>
        </div>
        <span class="panel-footer__count-pill" [class.is-connected]="item.connected">
          <span class="panel-footer__dot"></span>
          {{ (item.connected ? "panel-alerts.gateway-on" : "panel-alerts.gateway-off") | translate }}
        </span>
      </div>
    </div>
  </ng-template>

  <div class="panel-footer__progress">
    <small class="panel-footer__label">{{ "panel-alerts.progress" | translate }}</small>
    <div class="panel-footer__bar">
      <div class="panel-footer__bar-fill" [style.width.%]="progress.percentage"></div>
    </div>
    <small class="panel-footer__value">
      {{ progress.sent }}/{{ progress.total }} {{ "panel-alerts.sent" | translate }}
    </small>
  </div>

  <div class="panel-footer__counters">
    <!-- Cada contador: badge circular + valor arriba, etiqueta centrada debajo -->
    <div class="panel-counter is-answered">
      <span class="panel-counter__top">
        <span class="panel-counter__badge"><em class="fa fa-check" aria-hidden="true"></em></span>
        <span class="panel-counter__value">{{ counters.answered }}</span>
      </span>
      <small class="panel-counter__label">{{ "panel-alerts.answered" | translate }}</small>
    </div>
    <div class="panel-counter is-waiting">
      <span class="panel-counter__top">
        <span class="panel-counter__badge"><em class="fa fa-clock" aria-hidden="true"></em></span>
        <span class="panel-counter__value">{{ counters.waiting }}</span>
      </span>
      <small class="panel-counter__label">{{ "panel-alerts.waiting" | translate }}</small>
    </div>
    <div class="panel-counter is-error">
      <span class="panel-counter__top">
        <span class="panel-counter__badge"><em class="fa fa-times" aria-hidden="true"></em></span>
        <span class="panel-counter__value">{{ counters.with_error }}</span>
      </span>
      <small class="panel-counter__label">{{ "panel-alerts.with-error" | translate }}</small>
    </div>
  </div>

  <!-- Cola del backend: fila completa, solo cuando el lote supero el limite de envio -->
  <small
    class="panel-footer__queue"
    *ngIf="queue.waiting + queue.sent > 0"
    placement="top"
    container="body"
    [ngbTooltip]="'panel-alerts.queue-footer-tooltip' | translate"
  >
    <span class="is-waiting">
      <em class="fa fa-hourglass-half" aria-hidden="true"></em>
      {{ queue.waiting }} {{ "panel-alerts.queue-waiting" | translate }}
    </span>
    <span class="is-sent">
      <em class="fa fa-paper-plane" aria-hidden="true"></em>
      {{ queue.sent }} {{ "panel-alerts.queue-sent" | translate }}
    </span>
  </small>
</div>
